import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { AuthForm } from '../AuthForm'

import { Spinner } from '@percent/lemonade'
import { useAuthDispatch } from '@percent/partner-dashboard/common/hooks/useAuthDispatch/useAuthDispatch'
import { SET_AUTHORISED } from '@percent/partner-dashboard/context/auth'
import { useAuthState } from '@percent/partner-dashboard/common/hooks/useAuthState/useAuthState'
import styles from './SSO.module.scss'

export function SSOGateway() {
  const navigate = useNavigate()

  const dispatch = useAuthDispatch()
  const { isAuthorised } = useAuthState()

  useEffect(() => {
    if (isAuthorised) {
      navigate('/dashboard')
    }
  }, [isAuthorised, navigate])

  useEffect(() => {
    dispatch({
      type: SET_AUTHORISED
    })
    localStorage.authState = JSON.stringify({
      isAuthorised: true,
      isAuthorising: false
    })
  }, [dispatch])

  return (
    <AuthForm>
      <div className={styles.gatewaySpinnerWrapper}>
        <Spinner size={14} />
      </div>
    </AuthForm>
  )
}
